<ul>
  <ng-container *ngFor="let field of fields">
    <li *ngIf="field.visible" class="bl-padding-left--32">
      <cu-dynamic-field [page]="page" [card]="card" [field]="field" [pageSubmitted$]="pageSubmitted$"></cu-dynamic-field>
    </li>
  </ng-container>
</ul>
